export function space(ch: number): boolean { 
  return (isNaN(ch) || ch === 32 || ch === 9 || ch === 10 || ch === 13 
            || ch === 40 /* ( */ || ch === 60 /* < */ || ch === 91 /* [ */ || ch === 123 /* { */ )
}
